export default "__VITE_ASSET__phG6ue2r__"